export default "__VITE_ASSET__BVD9rEHS__"